export default "__VITE_PUBLIC_ASSET__adadc874__"